export default "__VITE_ASSET__$v695PQF__"